module.exports = __webpack_public_path__ + "5c2ceca0642eb2714c598f2c0573f48a.png";